var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cube-button',{class:[_vm.classes,_vm.danger && 'wt-button-danger' ],style:(_vm.style),attrs:{"light":_vm.light,"inline":_vm.inline,"outline":_vm.outline,"primary":_vm.primary,"icon":_vm.icon,"disabled":_vm.disabled,"active":_vm.active,"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }